import Clarity from '@microsoft/clarity'

export function initClarity() {
  if (import.meta.env.VITE_NODE_ENV === 'production') {
    const clarityID = import.meta.env.VITE_CLARITY_ID
    if (clarityID) {
      Clarity.init(clarityID)
    }
  }
}
